import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import { validFormats } from '@/constants/creativeLibrary';
import { formatFileSize } from '@/helpers/byteValueConverter.helpers';
import type { InlineCreativeType } from '@/types/creativeLibrary';

const displayFormat = validFormats[CreativeType.DISPLAY];
const videoFormat = validFormats[CreativeType.VIDEO];

export const fileUploadHints: Record<InlineCreativeType, string[]> = {
  [CreativeType.VIDEO]: [
    'File extension: .mp4 or .mov',
    'Duration: up to 90s',
    `File size: up to ${formatFileSize(videoFormat.maxFileSize)}`,
  ],
  [CreativeType.DISPLAY]: [
    'File extension: .jpg, .jpeg, .png or .gif',
    `File size: up to ${formatFileSize(displayFormat.maxFileSize)}`,
    `Max dimensions: ${displayFormat.maxWidth}x${displayFormat.maxHeight} px`,
  ],
  [CreativeType.HTML5]: [
    'File extension: .html',
    'File size: up to 2 MB',
    'To ensure clicks are being tracked for this creative, please include the click macro {{CLICK_URL}} into the HTML source code.',
  ],
  [CreativeType.AUDIO]: ['File extension: .mp3', 'Duration: up to 90s', 'File size: up to 2.8 MB'],
};
